'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defaultTheme = {};

exports.__exports = defaultTheme;
